import { LoadingContainer, LoadingDiv } from '../styles/LoaderStyles'

const Loader = () => {
	return (
		<LoadingContainer>
			<LoadingDiv></LoadingDiv>
		</LoadingContainer>
	)
}

export default Loader
